import type { AudioType } from "@expert/shared-types";

// TODO: Implement a mechanism to get the actual audio length.
// Hardcoded to match the {Partner}_{AudioType} Quick Connect voicemail length in Amazon Connect,
// keyed by SKU then AudioType. Each entry must match its corresponding Quick Connect recording —
// update the recording and this value together.
export const DISCLOSURE_LENGTH_SECONDS_BY_SKU: Record<string, Partial<Record<AudioType, number>>> = {
    HOMEPRO: {
        PreRecordedDisclosures: 47,
        // att_PreRecordedDisclosuresSpanish recording length: 1:31.3, rounded up to whole seconds.
        PreRecordedDisclosuresSpanish: 92,
    },
};

export const DISCLOSURE_MODAL_TEXT_BY_SKU: Record<string, Partial<Record<AudioType, string>>> = {
    HOMEPRO: {
        PreRecordedDisclosures:
            "AT&T HomeTech Protection is optional, costs $25/month plus tax, and renews monthly until canceled. " +
            "Cancel before your next billing cycle to avoid future charges, either online, by phone, or as described " +
            "in the plan Terms. Tech support begins Day 1. Breakdown and accidental damage from handling coverage on " +
            "eligible home tech begins Day 31 with repair, replacement, or reimbursement provided for approved claims. " +
            "This plan is not insurance; phones and pre-existing conditions are excluded. Claims include up to a $99 " +
            "service fee, with $2,000 per-claim and $5,000 rolling 12-month limits. Repairs and replacements may use " +
            "new, refurbished, or non-original parts. Terms, limits, exclusions, arbitration, class action waiver, and " +
            "electronic communications agreement apply at asur.me/htpterms. Plan-related communications will be sent " +
            "electronically.",
        PreRecordedDisclosuresSpanish:
            "El plan AT&T HomeTech Protection es opcional, cuesta 25 dólares por mes más impuestos y se " +
            "renueva mensualmente hasta que lo cancele. Para evitar futuros cargos, cancele el plan antes " +
            "del próximo ciclo de facturación, ya sea de manera en línea, por teléfono o como se describe " +
            "en los Términos del plan. Cuenta con soporte técnico desde el primer día. La cobertura por " +
            "averías y daños accidentales por manejo de tecnología del hogar elegible comienza el día 31, " +
            "con reparación, reemplazo o reembolso para los reclamos aprobados. Este plan no es un seguro; " +
            "se excluyen los teléfonos y las condiciones preexistentes. Los reclamos incluyen un cargo por " +
            "servicio de hasta 99 dólares, con límites de 2,000 dólares un límite acumulado de 5,000 dólares " +
            "durante cualquier período consecutivo de 12 meses. Las reparaciones y los reemplazos pueden " +
            "realizarse con piezas nuevas, reacondicionadas o no originales. Se aplican los términos, " +
            "límites, exclusiones, arbitraje, la renuncia al derecho de participar en demandas colectivas y " +
            "el acuerdo sobre comunicaciones electrónicas, disponibles en asur.me/htpterms. Las " +
            "comunicaciones relacionadas con el plan se enviarán por medios electrónicos. Las " +
            "comunicaciones relacionadas con el plan se enviarán electrónicamente.",
    },
};

export function getDisclosureLengthSeconds(productSku: string, audioType: AudioType): number | undefined {
    return DISCLOSURE_LENGTH_SECONDS_BY_SKU[productSku]?.[audioType];
}

export function getDisclosureModalText(productSku: string, audioType: AudioType): string | undefined {
    return DISCLOSURE_MODAL_TEXT_BY_SKU[productSku]?.[audioType];
}

/**
 * Whether the SKU has both a recording length and modal copy for the selected language — i.e. the
 * disclosure player can actually render. Mirrors RecordedLegalDisclosuresSection's own render gate so
 * the Enroll gate (FullOfferChecklistStep) never requires a disclosure that can't be shown, which
 * would otherwise leave the expert stuck behind a disabled Enroll.
 */
export function hasDisclosureContent(productSku: string, audioType: AudioType): boolean {
    return !!getDisclosureLengthSeconds(productSku, audioType) && !!getDisclosureModalText(productSku, audioType);
}
